import React from 'react'
import { RESOLUTIONS } from 'helpers/globals'
import parseResolutions from 'helpers/parseResolutions'
import ModelResolutionDisplay from './ModelResolutionDisplay'

function resolutionExists(resolution) {
  const horizontalResolution = parseResolutions(resolution).horizontal
  return RESOLUTIONS.some(({ value }) => {
    parseResolutions(value).horizontal === horizontalResolution
  })
}

class ResolutionContainer extends React.Component {
  childToRender({ props: { currentCamera: { model }, children } }) {
    if (!model || (model && resolutionExists(model.resolution))) {
      return React.Children.only(children)
    } else {
      return (
        <ModelResolutionDisplay resolutionName={model.resolution_name} resolutions={RESOLUTIONS} />
      )
    }
  }

  render() {
    return this.childToRender(this)
  }
}

export default ResolutionContainer



// WEBPACK FOOTER //
// ./src/components/ResolutionContainer/index.js